import { render } from "./HizliMenu.vue?vue&type=template&id=51878526"
import script from "./HizliMenu.vue?vue&type=script&lang=js"
export * from "./HizliMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__